
import { FiLayers, FiPlus, FiPrinter } from "react-icons/fi"
import useSWR from 'swr'
import _ from 'lodash'

import { ModalSector } from "../../components/Modals/Sector"
import { NavBar } from "../../components/NavBar"
import { api } from "../../api/api"
import './style.css'
import '../admin.css'
import { useContext, useState } from "react"
import { GlobalContext } from "../../context/GlobalContext"

export function SectorPage() {
  const { isAccess } = useContext(GlobalContext)

  const [selectSector, setSelectSelector] = useState(null)

  const { data, isLoading } = useSWR('/sectors', async () => {
    const response = await api.get('/sectors')
    return response.data
  })

  return (
    <>
      <ModalSector sectorSelect={selectSector} clearSelection={() => setSelectSelector(null)} />
      <NavBar>
        <main className="admin-page sector-page">
          <header className="admin-page-header">
            <div><h1>Setores</h1><p>Organize a produção e configure a impressão por setor</p></div>
            {isAccess('sector', 'create') && (
              <button className="admin-primary-button" onClick={() => setSelectSelector(null)} data-bs-toggle="modal" data-bs-target="#sectorModal"><FiPlus /> Novo setor</button>
            )}
          </header>

          {isLoading && (
            <div className="admin-loading"><div className="spinner-border" role="status"><span className="visually-hidden">Carregando...</span></div></div>
          )}

          {!isLoading && (
            <section className="admin-surface">
              <div className="admin-surface-header"><div><h2>Setores cadastrados</h2><p>{data?.length || 0} setores disponíveis</p></div><FiLayers size={19} /></div>
              <div className="admin-card-grid">
                {_.orderBy(data, (a) => a.name, 'asc').map(sector => {
                  return (
                    <article key={sector.id} className={`admin-item-card sector-card ${isAccess('sector', 'update') ? 'clickable' : ''}`} onClick={() => {
                      if (isAccess('sector', 'update')) {
                        setSelectSelector(sector)
                        new window.bootstrap.Modal(document.getElementById('sectorModal'), {}).toggle()
                      }
                    }}>
                      <div className="sector-card-icon"><FiLayers /></div>
                      <div className="sector-card-copy"><h3>{sector.name}</h3><p>{sector.description || 'Sem descrição'}</p></div>
                      <span className={`sector-print-status ${sector.namePrint ? 'configured' : ''}`}><FiPrinter /> {sector.namePrint ? 'Impressora configurada' : 'Sem impressora'}</span>
                    </article>
                  )
                })}
                {data?.length === 0 && <div className="admin-empty"><FiLayers size={25} /><strong>Nenhum setor cadastrado</strong><span>Crie um setor para organizar a produção.</span></div>}
              </div>
            </section>
          )}
        </main>
      </NavBar>
    </>
  )
}
